import fetch from "../../../utils/fetch";
import { urlBuilder } from "../../../helpers/url_builder_helper.js";

const stateInitial = {
  observations: [],
  observationsIsLoading: false,
  observationsTotal: null,
  observationsPage: 1,
  observationsPerPage: 10,
  observationsError: null,
};

const getters = {
  observations: (state) => state.observations,
  observationsIsLoading: (state) => state.observationsIsLoading,
  observationsTotal: (state) => state.observationsTotal,
  observationsPage: (state) => state.observationsPage,
  observationsPerPage: (state) => state.observationsPerPage,
  observationsFrom: (state) => {
    return state.observationsTotal > 0
      ? (state.observationsPage - 1) * state.observationsPerPage + 1
      : 0;
  },
  observationsTo: (state) => {
    return state.observationsTotal > 0
      ? Math.min(state.observationsPage * 10, state.observationsTotal)
      : 0;
  },
  observationsError: (state) => state.observationsError,
};

const t = {
  LOCATIONS_RESET_OBSERVATIONS: "LOCATIONS_RESET_OBSERVATIONS",
  LOCATION_SET_OBSERVATIONS_LOADING: "LOCATION_SET_OBSERVATIONS_LOADING",
  LOCATION_SET_OBSERVATIONS: "LOCATION_SET_OBSERVATIONS",
  LOCATION_SET_OBSERVATIONS_ERROR: "LOCATION_SET_OBSERVATIONS_ERROR",
  LOCATION_SET_OBSERVATIONS_PAGE: "LOCATION_SET_OBSERVATIONS_PAGE",
  LOCATION_SET_OBSERVATIONS_PER_PAGE: "LOCATION_SET_OBSERVATIONS_PER_PAGE",
};

const actions = {
  async fetchObservations({ commit, state }, ctx) {
    commit(t.LOCATION_SET_OBSERVATIONS_LOADING);
    return fetch("/areas/" + state.id + "/observations" + urlBuilder(ctx))
      .then((response) => response.json())
      .then((data) => {
        commit(t.LOCATION_SET_OBSERVATIONS, data);
      })
      .catch((e) => {
        commit(t.LOCATION_SET_OBSERVATIONS_ERROR, e.message);
      });
  },
};

const mutations = {
  [t.LOCATIONS_RESET_OBSERVATIONS](state) {
    state = stateInitial;
  },
  [t.LOCATION_SET_OBSERVATIONS_LOADING](state) {
    state.observationsIsLoading = true;
    state.error = null;
  },
  [t.LOCATION_SET_OBSERVATIONS](state, response) {
    state.observations = response["hydra:member"];
    state.observationsTotal = response["hydra:totalItems"];
    state.observationsIsLoading = false;
    state.error = null;
  },
  [t.LOCATION_SET_OBSERVATIONS_ERROR](state, error) {
    state.error = error;
    state.observationsIsLoading = false;
  },
  [t.LOCATION_SET_OBSERVATIONS_PAGE](state, page) {
    state.observationsPage = page;
  },
  [t.LOCATION_SET_OBSERVATIONS_PER_PAGE](state, perPage) {
    state.observationsPerPage = perPage;
  },
};

export default {
  state: stateInitial,
  getters,
  actions,
  mutations,
};
